<template>
	<div v-if="this.upTabType === 'rejected'">
		<div v-if="isFinalRejected">
			<span>{{$t("seller.sell.table.rejected.noResubmit") }}</span>
		</div>
		<div v-else class="operation_box">
			<div class="operation_item">
				<md-button class="md-primary" @click="clickEdit" ><i class="fa fa-pencil" style="text-align: left"></i>{{$t("common.edit") }}</md-button>
			</div>
		</div>
	</div>

	<div v-else class="operation_box">
		<div class="operation_item">
			<el-dropdown
				v-if="this.upTabType === 'new'"
				split-button type="primary"
				@click="clickEdit"
				@command="(command) => command()"
			>
				<i class="fa fa-pencil"></i>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item :command="clickEdit">
						<i class="fa fa-pencil"></i> {{ $t("common.edit") }}
					</el-dropdown-item>
					<el-dropdown-item :command="clickSubmit" v-if="showSubmit" :disabled="!canSubmit">
						<i class="fa fa-paper-plane"></i> {{ $t("common.button.toReview") }}
					</el-dropdown-item>
					<el-dropdown-item :command="clickDelete" v-if="showDelete">
						<i class="fa fa-trash-o"></i> {{ $t("common.delete") }}
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>

			<div @click="clickDetails" v-if="this.upTabType === 'waiting'">
				<md-button class="md-blank"><i class="fa fa-search-plus"
											   style="text-align: left"></i><span>{{ $t("common.details") }}</span>
				</md-button>
			</div>
		</div>
	</div>
</template>
<script>
import {mapGetters} from "vuex";
import {hasAccess} from "@/common/permission/permission";
import {enumDef} from "@/common/enumDefs";
import {isValueSet} from "@/common/format";

export default {
	methods: {
		clickEdit() {
			let { data, colDef } = this.params;
			colDef.editFun(data);
		},
		clickDelete() {
			let { data, colDef } = this.params;
			colDef.delFun(data);
		},
		clickSubmit() {
			let { data, colDef } = this.params;
			colDef.setFun(data);
		},
		clickDetails() {
			let { data } = this.params;
			this.$store.dispatch("setActionNoticModal", {
				show: true,
				data: {
					title: this.$t("ReceDetail.Receivable.Details"),
					type: "ReceivableDetailsModal",
					width: 800,
					data: data
				}
			});
		}
	},
	computed: {
		...mapGetters({ upTableData: "upTableData", upTabType: "upTabType" }),
		belongsToInstallmentContract() {
			let { data } = this.params;
			return data.installmentContractId;
		},
		isFinalRejected() {
			return this.params.data.finalRejected;
		},
		showDelete() {
			let { data } = this.params;
			return enumDef.receivableStatus.isDeletable(data.status) && !isValueSet(data.opportunityStatus) && !data.convertedFromUpcomingOpportunity && !this.belongsToInstallmentContract;
		},
		showSubmit() {
			return !this.belongsToInstallmentContract;
		},
		canSubmit() {
			let { data } = this.params;
			return !!(data.invoiceNumber && data.invoiceDocument) && hasAccess(this.currentUser, enumDef.permissions.SellerSellReceivables) && !this.belongsToInstallmentContract;
		}
	}
};
</script>
